import { api } from "./api";

/** Mirrors MpConnectionStatusDto on the API. */
export type MpConnectionStatus = {
  /** False until the platform's MP OAuth app is configured. Nothing a provider does can
   *  change this — it gates the whole feature. */
  marketplaceConfigured: boolean;
  connected: boolean;
  status: number | null;
  mpUserId: string | null;
  connectedAt: string | null;
  accessTokenExpiresAt: string | null;
  /** True when the connection is broken, or the refresh token is within 14 days of expiry
   *  and the provider should reconnect while they still can. */
  needsReconnect: boolean;
};

export function getMercadoPagoStatus(): Promise<MpConnectionStatus> {
  return api<MpConnectionStatus>("/providers/mercadopago/status");
}

/** Returns Mercado Pago's consent URL. The caller navigates the browser to it; MP then
 *  redirects back to /provider/dashboard?mp=... */
export function startMercadoPagoConnect(): Promise<{ authorizeUrl: string }> {
  return api<{ authorizeUrl: string }>("/providers/mercadopago/connect", { method: "POST" });
}

export function disconnectMercadoPago(): Promise<void> {
  return api<void>("/providers/mercadopago/connect", { method: "DELETE" });
}
